<template>
    <div class="tabs-container">
        <div :class="['tab', tab.class, { selected: isTabSelected(tab) }]" v-for="tab in tabs" @click="selectTab(tab)">
            <el-tooltip :disabled="isTabSelected(tab)" :content="tab.label" placement="top"><div class="icon md-icon"></div></el-tooltip>
            <div class="label">{{ tab.label }}</div>
            <el-tooltip v-if="createAllowed" :content="$t('create')" :open-delay="500" placement="top"><div class="create-button md-icon" @click="createEntity">add</div></el-tooltip>
        </div>
    </div>
</template>

<script lang="ts">
    import { Context } from '@/utilities/contex';
    import { Tab } from '@/utilities/navigation';
    import Vue, { PropType } from 'vue';

    export default Vue.extend({
        name: 'tag',
        props: {
            tabs: Array as PropType<Tab<any>[]>,
            value: null as any,
            showCreate: Boolean,
        },
        computed: {
            createAllowed() {
                return this.showCreate && Context.user.accessSettings.createEntity;
            },
        },
        methods: {
            isTabSelected(tab: Tab<any>) {
                return tab.value == this.value;
            },
            selectTab(tab: Tab<any>) {
                this.$emit('input', tab.value);
            },
            createEntity() {
                this.$emit('create-entity', this.value);
            },
        }
    });

</script>

<style scoped lang="scss">

    .tabs-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        min-width: 0;

        .tab {
            display: flex;
            flex-direction: row;
            align-items: center;
            border-radius: 40px;
            transition: all .25s linear;
            flex-basis: 100%;
            padding: 8px 14px;
            background-color: var(--tab-background-color, var(--primary-100));
            cursor: pointer;
            min-width: 40px;

            .icon {
                flex-shrink: 0;
                font-size: 24px;
                color: var(--tab-text-color, var(--primary-500));

                &::before {
                    content: var(--tab-icon, 'label');
                }
            }

            .label {
                @extend %body-14-24-medium;
                @extend %no-overflow;
                color: var(--tab-text-color, var(--primary-500));
                flex-basis: 100%;
                padding-left: 8px;
            }

            .create-button {
                width: 24px;
                font-size: 24px;
                margin-right: -6px;
                color: var(--tab-text-color, var(--primary-500));
                overflow: hidden;
                flex-shrink: 0;
            }

            &:not(.selected) {
                flex-basis: 0;
                padding: 8px;

                &:not(:hover) {
                    background-color: transparent;
                }

                .create-button {
                    width: 0px;
                }
            }
        }
    }

</style>